import { EntregaPrestacaoDeContasLRFCI } from "@/types/entregas/lrfci/entrega-prestacao-contas-lrfci";
import { FiltrosPrestacaoContasLRFCI } from "@/types/entregas/lrfci/filtros-prestacao-contas-lrfci";
import { PrestacaoDeContasLRFCI } from "@/types/entregas/lrfci/prestacao-contas-lrfci";
import { Service } from "../mainService";
import { RetornoRelatorio } from "@/types/relatorios/retorno-relatorio";
import { PortalError } from "@/types/portal-error";

const lrfService = {
  // filtros
  getCombosConsultaLRF,
  getPeriodosRelatorio,
  // ações
  consultarLRF,
  salvarLRF,
  getLRFById,
  downloadEntrega,
  downloadRecibo,
};

/**
 * @returns os três combos que são utilizados na página de consulta de entregas de relatórios da LRF e CI.
 * @since 20220722
 */
async function getCombosConsultaLRF() {
  try {
    const anosEntrega = await Service.$http.get(
      process.env.VUE_APP_ENTREGAS_API + "/lrfci/anosEntrega"
    );
    const tiposRelatorio = await Service.$http.get(
      process.env.VUE_APP_ENTREGAS_API + "/lrfci/tiposRelatorio"
    );
    const situacoes = await Service.$http.get(
      process.env.VUE_APP_ENTREGAS_API + "/lrfci/situacoes"
    );
    return {
      anosEntrega: anosEntrega.data,
      tiposRelatorio: tiposRelatorio.data,
      situacoes: situacoes.data,
    };
  } catch (e: any) {
    return e.response;
  }
}

/**
 * @returns lista de PeriodoRelatorio que pertencem ao tipoRelatório recebido
 * @since 20220725
 */
async function getPeriodosRelatorio(tipoRel: string) {
  try {
    const periodos = await Service.$http.get(
      process.env.VUE_APP_ENTREGAS_API +
        "/lrfci/periodosRelatorio?tipo=" +
        tipoRel
    );
    return periodos.data;
  } catch (e: any) {
    return e.response;
  }
}

/**
 * @returns lista de PeriodoRelatorio que pertencem ao tipoRelatório recebido
 * @since 20220725
 */
async function consultarLRF(
  filtros: FiltrosPrestacaoContasLRFCI,
  page: number
) {
  try {
    const parametros = `?page=${page}&pageSize=10${filtros.toQueryString()}`;
    const resp = await Service.$http.get(
      process.env.VUE_APP_ENTREGAS_API + "/lrfci/consultarLRF" + parametros
    );
    return resp;
  } catch (e: any) {
    return e.response;
  }
}

/**
 * @returns Entrega de LRF
 * @since 20220901
 */
async function getLRFById(id: number): Promise<PrestacaoDeContasLRFCI> {
  try {
    const parametros = `?idLRF=${id}`;
    const resp = await Service.$http.get(
      process.env.VUE_APP_ENTREGAS_API + "/lrfci/lrfById" + parametros
    );
    const lrf = Object.assign(new PrestacaoDeContasLRFCI(), resp.data);
    lrf.tratarDadosDaAPI();
    return lrf;
  } catch (e: any) {
    return e.response;
  }
}

async function salvarLRF(prestacao: EntregaPrestacaoDeContasLRFCI) {
  try {
    const response = await Service.$http.post(
      process.env.VUE_APP_ENTREGAS_API + "/lrfci/salvarLRF",
      prestacao.toFormData(),
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (e: any) {
    console.error("capotou no service", e);
    return e.response;
  }
}

async function downloadEntrega(idEntrega) {
  try {
    const response = await Service.$http.get(
      process.env.VUE_APP_ENTREGAS_API + "/lrfci/downloadLRF/" + idEntrega,
      { responseType: "blob" }
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function downloadRecibo(idEntrega): Promise<RetornoRelatorio> {
  const url = `${process.env.VUE_APP_REPORTS_API}/relatorio/relatorioLrf?idLRF=${idEntrega}&nomeRel=ReciboLRF`;
  const response = await Service.$http.get(url);
  if (response.status === 200) {
    return response.data;
  }
  console.error("Falha ao carregar recibo de LRF", response);
  throw new PortalError(
    response.data?.msg ?? "Erro ao carregar recibo, por favor tente novamente"
  );
}

export default lrfService;
